import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from "react-router-dom";

const useQuery = () => new URLSearchParams(useLocation().search);

const LanguageSelector = () => {
  const { t } = useTranslation('commons');
  const language = useQuery().get("language") || 'en';
  return (
    <div className="text-right">
      <span className="text-muted mr-2">{t('languageSelectorLabel')}:</span>
      <ul className="list-unstyled d-inline-block">
        { language !== 'es' ? <strong>EN</strong> : <Link to={location => `${location.pathname}`} replace>EN</Link> }
        &nbsp;|&nbsp;
        { language === 'es' ? <strong>ES</strong> : <Link to={location => `${location.pathname}?language=es`} replace>ES</Link> }
      </ul>
    </div>
  );
};

export default LanguageSelector;
